module.exports = __webpack_public_path__ + "img/3-1.21d9a4ff.svg";